import { Button, Input, Modal, Select, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { ModalTitle } from '../../components/text/Titles';
import { User } from '../../types/users';
import * as Yup from 'yup';

interface Props {
  visible: boolean;
  onSubmit: (values: User) => any;
  onCancel: () => void;
}

const validationSchema = Yup.object({
  username: Yup.string()
    .email('Username should be a valid email address')
    .required('Username is required'),
});

const AddUser = ({ visible, onSubmit, onCancel }: Props) => {
  const [username, setUsername] = useState<string>('');
  const [role, setRole] = useState<string>('USER');
  const [valid, setValid] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    validationSchema
      .validate({ username: username })
      .then(value => {
        setValid(true);
        setError('');
      })
      .catch(error => {
        if (username) {
          setValid(false);
          setError(error.errors);
        }
      });
  }, [username]);

  const handleOk = () => {
    onSubmit({ username: username, role: role });
    setUsername('');
  };

  const handleCancel = () => {
    setUsername('');
    setError('');
    onCancel();
  };

  return (
    <Modal
      title={<ModalTitle>Add user</ModalTitle>}
      onCancel={handleCancel}
      visible={visible}
      footer={
        <div className="text-right">
          <Button type="default" onClick={handleCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleOk} disabled={!valid}>
            Save
          </Button>
        </div>
      }>
      <Form layout={'vertical'}>
        <Form.Item name="username" label="Username">
          <Input value={username || ''} onChange={event => setUsername(event.target.value)} />
          <p className="mt-2 text-red-600">{error}</p>
        </Form.Item>
        <Form.Item name="role" label="Role">
          <Select value={role} defaultValue="USER" onChange={(value: string) => setRole(value)}>
            {['ADMIN', 'USER'].map(role => (
              <Select.Option key={role} value={role}>
                {role}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddUser;
